/**
 * KanbanColumn.tsx - KanbanColumn - Column component for Kanban board
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import KanbanCard from './KanbanCard';

const KanbanColumn = ({ 
  id, 
  title, 
  color,
  items, 
  getField,
  onAddCard, 
  onCardClick,
  onCardContextMenu,
  columnStyles = {},
  cardStyles = {}
}) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      type: 'column',
      status: id,
    },
  });

  return (
    <div 
      className="kanban-column" 
      ref={setNodeRef}
      style={columnStyles}
    >
      <div className="kanban-column-header" style={{ borderLeftColor: color }}>
        <h3>{title}</h3>
        <span className="item-count">{items.length}</span>
      </div>
      
      <div className="kanban-column-content">
        <SortableContext 
          items={items.map(item => item.id)} 
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <KanbanCard
              key={item.id}
              item={item}
              columnId={id}
              getField={getField}
              onClick={() => onCardClick && onCardClick(item)}
              onContextMenu={onCardContextMenu}
              cardStyles={cardStyles}
            />
          ))}
        </SortableContext>
      </div>
    </div>
  );
};

export default KanbanColumn;
